export default {
  // ข้อมูลส่วนบุคคล
  info: {
    title: "ข้อมูลส่วนบุคคล",
    birthdate: "วัน / เดือน / ปี เกิด",
    gender: "เพศ",
    address: "ที่อยู่",
    ethnicity: "เชื้อชาติ",
    nationality: "สัญชาติ",
    religion: "ศาสนา",
    maritalStatus: "สถานภาพสมรส",
    militaryStatus: "สถานะทางทหาร",
    disabled: "ผู้พิการ",
    phone: "เบอร์โทรศัพท์",
    email: "อีเมล",
    lastUpdated: "อัพเดตเรซูเม่ล่าสุด",
  },

  // ประวัติย่อ
  resume: {
    title: "เรซูเม่ที่แนบมา",
    validText: "ถูกต้อง",
    invalidText: "ไม่ถูกต้อง",
  },

  // ความต้องการในการทำงาน
  jobPre: {
    title: "ลักษณะงานที่ต้องการ",
    jobType: "รูปแบบสายงาน",
    businessSector: "ลักษณะองค์กร",
    empType: "รูปแบบการจ้างงาน",
    jobPosition: "ตำแหน่งงาน",
    expectedSalary: "ค่าตอบแทนที่ต้องการ",
    startDate: "วันที่สามารถเริ่มงานได้",
    workLocation: "พื้นที่ที่ต้องการทำงาน",
    workingStyles: "ลักษณะการทำงาน",
  },

  // ประวัติการศึกษา
  edu: {
    title: "ประวัติการศึกษา",
    institution: "สถานศึกษา",
    schoolName: "ชื่อโรงเรียน",
    schoolMajor: "สายการเรียน",
    grade: "ระดับชั้น",
    universityName: "ชื่อมหาวิทยาลัย",
    degree: "วุฒิการศึกษา",
    faculty: "คณะ",
    major: "สาขา",
    startDate: "วันเริ่มต้น",
    endDate: "วันสิ้นสุด",
    gpa: "เกรดเฉลี่ย",
  },

  // ประสบการณ์การทำงาน
  workExp: {
    title: "ประวัติการทำงาน /ฝึกงาน",
    totalExpYears: "ประสบการณ์ทำงานทั้งหมด",
    noExp: "ไม่มีประสบการณ์",
    companyName: "ชื่อบริษัท",
    businessSector: "ประเภทธุรกิจ",
    position: "ตำแหน่ง",
    jobType: "รูปแบบสายงาน",
    empType: "รูปแบบการจ้างงาน",
    startDate: "วันเริ่มงาน",
    endDate: "วันสิ้นสุดงาน",
    Responsibilities: "หน้าที่ความรับผิดชอบ",
    salary: "เงินเดือน (บาท)",
    currentJob: "งานปัจจุบัน",
  },

  // ประสบการณ์การฝึกอบรม
  trainExp: {
    title: "ประวัติการฝึกอบรม / ประกาศนียบัตร",
    trainingName: "ชื่อการฝึกอบรม",
    organization: "หน่วยงานที่จัด",
    certificateOwner: "ผู้ออกใบประกาศการฝึกอบรม",
    DateOfIssue: "วันที่ออกเอกสาร",
  },

  // ทักษะ
  skill: {
    title: "ทักษะ",
  },

  // ทักษะด้านภาษา
  langSkills: {
    title: "ภาษา",
    tableHead: {
      reading: "การอ่าน",
      writing: "การเขียน",
      speaking: "การพูด",
      listening: "การฟัง",
    },
    testTitle: "ผลการสอบวัดระดับภาษา",
  },

  // ความสามารถในการขับขี่ยานพาหนะ
  drivingSkill: {
    title: "ความสามารถในการใช้งานพาหนะ",
    subTitle: "ความสามารถในการขับขี่",
    car: "รถยนต์",
    motorcycle: "รถจักรยานยนต์",
    other: "อื่นๆ",
    ownVehicle: "มีพาหนะส่วนตัว",
  },

  // โครงการ ผลงาน รางวัล และประสบการณ์อื่น ๆ
  project: {
    title: "โครงการ ผลงาน เกียรติประวัติและประสบการณ์อื่นๆ",
    participationDate: "วันที่เข้าร่วม",
  },

  //button titles
  btn: {
    back: "โปรไฟล์",
    downloadProfile: "ดาวน์โหลดโปรไฟล์",
    printProfile: "พิมพ์โปรไฟล์",
  },
};
